import { GridWrapper } from "../wrapper";
import { styled } from "@mui/material/styles";

export const GridHalfScreen = styled(GridWrapper)(() => ({
    flexGrow: 1,
    flexBasis: "50%",
}));